import { FC, memo, useCallback } from 'react'
import { Modal } from 'components/layouts/modal/modal'
import { useTranslation } from '@crew/modules/i18n'
import { GroupChatMemberPanel } from './components/groupChatMemberPanel/groupChatMemberPanel'

type GroupChatAddMemberDialogProps = {
  projectId: string
  isOpen: boolean
  onAddUsers: (userIds: string[]) => void
  onClose: () => void
}

// グループチャットメンバー追加ダイアログ
export const GroupChatAddMemberDialog: FC<GroupChatAddMemberDialogProps> = memo(
  (props) => {
    const { t } = useTranslation()

    // ダイアログを閉じる際に呼ばれるハンドラ
    const handleClose = useCallback(() => {
      props.onClose()
    }, [props])

    return (
      <Modal
        title={t('action.addUser')}
        isOpen={props.isOpen}
        onClose={handleClose}
      >
        <div className="h-full flex flex-col">
          <GroupChatMemberPanel
            projectId={props.projectId}
            onAddUsers={props.onAddUsers}
            onClose={handleClose}
          />
        </div>
      </Modal>
    )
  }
)
